import {Tabs} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo} from 'react'
import {Switch, useParams} from 'react-router-dom'
import {gConfigs, gPaths} from 'views/AppLocals/configs'
import {mapPathParam} from 'views/AppLocals/functions/routerHelper'
import useNavRouteAction from 'views/AppLocals/hooks/useNavRouteAction'
import {NavRoutes} from 'views/AppLocals/hooks/useNavRoutes'
import {notEmpty, NullAsDefault, scrollToSection} from 'views/Shared'
import {Queries} from 'views/Shared/enums/Queries'
import {SubDomainContext} from 'views/SubDomain/SubDomainContext'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {FiChevronsRight} from "react-icons/fi";

const OrganizationNav = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {isSubDomain, url_domain, url_pathname, ...rest} =
        useContext(SubDomainContext)

    const params = useParams()

    const history = useHistory()

    const id = _.get(params, 'id')

    const withSubDomain = Boolean(isSubDomain && !id)

    const rootPath = withSubDomain
        ? gPaths.organization_domain
        : gPaths.organization

    const {
        isValidRoute = NullAsDefault,
        routeEntities = [],
        getDefaultAction = NullAsDefault,
        organization = {},
        set_route_data = NullAsDefault,
    } = useContext(OrganizationContainerContext)

    const defaultAction = "news"

    const {currentAction} = useNavRouteAction({
        anchor: id,
        defaultAction,
        isAction: isValidRoute,
        getActionParam: withSubDomain
            ? (pathname) => {
                const pattern =
                    rootPath == '' ? pathname : _.last(String(pathname).split(rootPath))
                const _action = pattern.substring(pattern.startsWith('/') ? 1 : 0)
                return _.isEmpty(_action.trim()) ? defaultAction : _action
            }
            : undefined,
    })

    useEffect(() => {
        set_route_data({
            [Queries.REL]: currentAction,
        })
    }, [currentAction])

    const pathTransform = useCallback(
        (path, segment) =>
            [
                _.isEmpty(id)
                    ? path
                    : mapPathParam(path, {
                        id,
                    }),
                segment,
            ]
                .filter(notEmpty)
                .join('/'),
        [id]
    )

    const tabItems = useMemo(
        () =>
            routeEntities
                .filter(
                    ({isInvisible = NullAsDefault}) =>
                        !isInvisible({item: organization})
                )
                .map(({path, breadcrumbName = NullAsDefault}) => ({
                    key: path,
                    label: breadcrumbName(t),
                    children: (
                        <NavRoutes
                            rootPath={rootPath}
                            routes={routeEntities}
                            transform={pathTransform}
                            defaultAction={defaultAction}
                            renderRoutes={
                                withSubDomain
                                    ? (routes, redirect) => (
                                        <Switch>
                                            {routes}
                                            {redirect}
                                        </Switch>
                                    )
                                    : undefined
                            }
                        />
                    ),
                })),
        [
            t,
            rootPath,
            organization,
            defaultAction,
            routeEntities,
            pathTransform,
            withSubDomain,
        ]
    );

    return (
        <Wrapper id="contentOrg" className="background-50">
            <Tabs
                id="tab_content" type="line"
                className="custom-tabs-organization"
                tabBarStyle={gConfigs.styles2.tabBar}
                destroyOnHidden={false}
                onChange={(activeKey) => {
                    setTimeout(() => {
                        scrollToSection("tab_content")
                    }, 1000);
                    history.push({
                        pathname: pathTransform(rootPath, activeKey),
                        // hash: '#content',
                    })
                }}
                items={tabItems}
                activeKey={currentAction}
                tabBarExtraContent={ !!!isLg &&
                    <FiChevronsRight size={14} className="mx-3 flex text-color-300"/>
                }
            />
        </Wrapper>
    )
}

export default OrganizationNav
